<style lang="stylus">
    .remind-mask
      position fixed
      width 100vw
      height 100vh
      z-index 233
      top 0
      left 0
      background-color var(--bg-color-dialog-mask)
      .remind-box
        position absolute
        left 50%
        top 50%
        transform translate(-50%, -50%)
        width 512px
        max-width 100%
        background-color var(--bg-color-dialog-container)
        border-radius 8px
        box-shadow 0 1px 6px rgba(0,0,0,.2)
        .topbar
          width 100%
          padding 12px 12px 12px 24px
          // border-bottom 1px solid #e0e0e0
          height 40px;
          display flex
          justify-content space-between
          align-items center
          .title
            font-size 14px
            line-height 18px
            font-weight 700;
            color: var(--text-color-primary);
          .close
            cursor pointer
            svg
              width 16px
              height 16px
              color var(--svg-color-primary)

        .tips-title-box,.content
          display flex
          justify-content center
          align-items center
        .remind-box-content
          margin 0 24px 24px
          &.scale-remind
            .warn
                img
                    width 160px;
                    margin-bottom 8px
            .tips-title-box
                flex-direction column
                .tips-title
                    font-size 12px;
                    line-height 16px;
                    font-weight 400;
                    color: var(--text-color-primary);
                    margin-bottom 24px;
                .tips-title-refresh
                    font-weight 700;
                    font-size 18px;
                    line-height 24px
                    color: #017FFF;
            .ratio-content
                margin 16px auto 24px
                padding 20px 0 20px 24px
                border-radius 8px;
                background: var(--bg-color-dropdown-item-hover);
                align-items unset;
                .ratio-content-box
                    p
                        font-size 14px;
                        line-height 18px;
                        margin-bottom 8px;
                        &:first-child
                            margin-bottom 12px;
                        &:last-child
                            margin-bottom 0
            .btn-box
                flex-direction: row;
                justify-content space-between
                height 32px;
                align-items center;
                line-height 32px
                .left
                    height 32px;
                    display: flex;
                    align-items center;
                    .no-remind
                        vertical-align middle
                    .ivu-checkbox-inner:after
                        transition unset
                    .ivu-checkbox-wrapper
                        width 100%
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                        font-size: 14px;
                        line-height 18px
                        .ivu-checkbox
                            margin-right: 8px
                            height 16px;
                            width 16px;
                            &.ivu-checkbox-checked
                                .ivu-checkbox-inner:after
                                    width: 10px;
                                    height: 8px;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate3d(-50%, -50%, 0);
                                    background-repeat: no-repeat;
                                    background-image url(../../app/assets/checked.svg);
                                    border-color: transparent;
                            .ivu-checkbox-inner
                                height 16px;
                                width 16px;
                                &:after
                                    transition all 0.1s linear;
                                &.ivu-checkbox-focus
                                    box-shadow  none;
                .right
                    display flex;
                    align-items center;
                    column-gap 16px;
                    .btn
                        min-width 96px;
                        border-radius 6px;
                        background: rgba(235, 237, 241, 1);
                        font-size 12px;
                        line-height 16px;
                        color: rgba(0, 0, 0, 1);
                        box-shadow none;
                        height 32px;
                        padding 0;
                        max-width auto;
                        &:hover
                            background: #dddfe3;
                        &.reload
                            background: var(--themeColor);
                            color: #fff;
                            &:hover
                                background-color var(--themeHover)

          .warn
            display flex
            justify-content center
            align-items center
              img
                max-width 100%
          .tips-title
            width 324px
            text-align center
            font-weight bold
            font-size 18px
            line-height 30px
            color #37393D
          .content
            flex-direction column
            margin 24px auto 60px
            p
              text-align center
              font-size 12px
              line-height 17px
              color #333333
              &:first-child
                padding-bottom 6px
          .ratio-content
            display flex
            flex-direction column
            justify-content center
            align-items center
            margin 20px auto 38px
            font-size 12px
            line-height 24px
            .ratio-content-box
              width 420px
              max-width 100%
              p
                max-width 420px
                margin 0 auto
                text-align left
                span
                    color #5598ff
          .btn-box
            position relative
            display flex
            flex-direction column
            justify-content center
            align-items center
            font-size 16px
            line-height 24px
            .btn
              padding 0 44px
              max-width 100%
              height 40px
              text-align center
              display flex
              justify-content center
              align-items center
              color white
              cursor pointer
              background linear-gradient(92.16deg, #549BFF 0%, #625EFF 100%)
              border-radius 36px
              box-shadow 6px 9px 12px #d7dae6
            .remind-text
              margin-top 12px
              color #8c8c8c
              cursor pointer
              user-select none
              &:hover
                  color #adadad
      @media screen and (max-height: 700px)
        .remind-box
          width 480px
          .remind-box-content
            .warn
              img
                width 150px
            .tips-title
              font-size 16px
</style>
<template>
    <div class="remind-mask">
        <div class="remind-box">
            <div class="topbar">
                <p class="title">{{ $t("remind") }}</p>
                <div v-if="Remindtype == 1" class="close" @click="closeRemindFun">
                    <iconSymbol name="compatible-close" />
                </div>
                <div v-if="Remindtype == 2" class="close" @click="closeRatioRemindFun">
                    <iconSymbol name="compatible-close-scale" />
                </div>
            </div>
            <div class="remind-box-content" :class="{ 'scale-remind': Remindtype == 2 }">
                <div class="warn">
                    <img src="@/app/assets/img/dialog/incompatible.svg" alt="" />
                </div>
                <!-- 浏览器不兼容提示 -->
                <div v-if="Remindtype == 1">
                    <div class="tips-title-box">
                        <div class="tips-title" v-if="!fullUnCompatible">{{ $t("chrome-tips") }}</div>
                        <div class="tips-title" v-if="fullUnCompatible">{{ $t("ie-tips") }}</div>
                    </div>
                    <div class="content">
                        <p>
                            {{ $t("chrome1") }}
                            <span>{{ $t("chrome1-desc") }}</span>
                            。
                        </p>
                        <p>{{ $t("chrome2") }}</p>
                    </div>
                    <div class="btn-box">
                        <a class="btn" :href="downloadUrl" target="_blank">{{ $t("download") }}</a>
                        <p class="remind-text" @click="cancelChromeRemind">{{ $t("confirm") }}</p>
                    </div>
                </div>
                <!-- 浏览器缩放提示 -->
                <div v-if="Remindtype == 2">
                    <div class="tips-title-box">
                        <div class="tips-title">{{ $t("ratio-tips") }}</div>
                        <div class="tips-title-refresh">{{ $t("ratio-tips-refresh") }}</div>
                    </div>
                    <div class="ratio-content">
                        <div class="ratio-content-box">
                            <p>{{ $t("divixWarn") }}</p>
                            <p>1、{{ $t("divixHelp1") }}</p>
                            <p>2、{{ $t("divixHelp2") }}</p>
                            <p>3、{{ $t("divixHelp3") }}</p>
                        </div>
                    </div>
                    <div class="btn-box">
                        <div class="left">
                            <Checkbox :value="noRemind" @click.prevent.native="checkRemind">
                                <span class="no-remind">{{ $t("noRemind") }}</span>
                            </Checkbox>
                        </div>
                        <div class="right">
                            <div class="btn reload" @click="refresh">
                                {{ $t("refreshNow") }}
                            </div>
                            <div class="btn continue" @click="closeRatioRemindFun">
                                {{ $t("confirm") }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Prop, Vue, Watch, Provide, Component } from "vue-property-decorator";
    @Component({})
    export default class App extends Vue {
        @Prop(Number)
        Remindtype: number;
        @Prop(Boolean)
        fullUnCompatible: boolean;
        noRemind = false;

        get downloadUrl() {
            return this.internal ? "https://www.google.cn/chrome/" : "https://www.google.com/chrome/";
        }
        closeRemindFun() {
            this.$bus.$emit("closeUnCompatibilityRemind");
        }

        closeRatioRemindFun() {
            this.$bus.$emit("closeRatioRemind");
        }

        cancelChromeRemind() {
            this.closeRemindFun();
        }
        cancelRemind() {
            this.closeRatioRemindFun();
            window.localStorage.setItem("remindRatio", "1");
        }

        refresh() {
            window.location.reload();
        }

        checkRemind() {
            this.noRemind = !this.noRemind;
            if (this.noRemind) {
                window.localStorage.setItem("remindRatio", "1");
            }
        }

        mounted() {}

        created() {}
    }
</script>

<i18n>
{
  "zh": {
    "remind": "温馨提示",
    "chrome-tips": "很抱歉，当前浏览器并未完全兼容，将会导致部分功能无法使用。",
    "ie-tips": "很抱歉，当前浏览器无法兼容亿图图示在线版",
    "ratio-tips": "很抱歉，当前页面缩放比例兼容性较差",
    "ratio-tips-refresh": "若展示异常请刷新页面",
    "chrome1": "为了您有更好的使用体验，我们建议您使用 ",
    "chrome1-desc": "谷歌浏览器（100%兼容）",
    "chrome2": "如果您正在使用360/搜狗/QQ等支持多种模式的浏览器，请尝试切换至高速/极速模式。",
    "divixWarn": "为了您有更好的使用体验，我们建议您：",
    "divixHelp1": "请尝试调整浏览器缩放比例为100%，或重置页面显示比例",
    "divixHelp1-desc": "快捷键Ctrl + 0",
    "divixHelp2": "调整系统显示比例为系统推荐显示比例",
    "divixHelp2-desc": "(window设置>系统>显示)",
    "divixHelp3": "调整后，请保存文件并刷新此页面",
    "download": "下载谷歌浏览器",
    "confirm": "继续使用",
    "refreshNow": "立即刷新",
    "noRemind": "不再提醒"
  },
  "en": {
    "remind": "Reminder",
    "chrome-tips": "The current browser is not fully compatible and some features will not work.",
    "ie-tips": "The current browser is not compatible with EdrawMax Online",
    "ratio-tips": "Sorry, the current page scaling compatibility is poor",
    "ratio-tips-refresh": "Please refresh the page if the display is abnormal",
    "chrome1": "For your better experience, we recommend using ",
    "chrome1-desc": "Google Chrome (100% compatible).",
    "chrome2": "If you use a browser that supports multiple modes such as 360/Sogou/QQ, please switch to high speed/extreme speed mode.",
    "divixWarn": "For your better experience, we recommend that you:",
    "divixHelp1": "Adjust the browser zoom ratio to 100%",
    "divixHelp1-desc": "shortcut key: Ctrl 0",
    "divixHelp2": "Adjust the system display ratio to the system recommended display ratio",
    "divixHelp2-desc": "(windows settings > system > display)",
    "divixHelp3": "After adjustment, please save the file and refresh this page",
    "download": "Download Google Chrome",
    "confirm": "continue",
    "refreshNow": "Refresh",
    "noRemind": "Don't remind again"
  },
  "fr": {
    "remind": "rappeler",
    "chrome-tips": "Le navigateur actuel n'est pas entièrement compatible et certaines fonctionnalités ne fonctionneront pas.",
    "ie-tips": "Le navigateur actuel n'est pas compatible avec EdrawMax Online",
    "ratio-tips": "Désolé, la compatibilité de mise à l'échelle de la page actuelle est médiocre",
    "ratio-tips-refresh": "Actualisez la page si l'affichage est anormal",
    "chrome1": "Pour une meilleure expérience, nous vous recommandons d'utiliser ",
    "chrome1-desc": "Google Chrome (100% compatible).",
    "chrome2": "Si vous utilisez un navigateur qui prend en charge plusieurs modes, comme 360/Sogou/QQ, veuillez passer en mode haute vitesse/extrême vitesse.",
    "divixWarn": "Pour une meilleure expérience, nous vous recommandons:",
    "divixHelp1": "Réglez le taux de zoom du navigateur à 100%",
    "divixHelp1-desc": "touche de raccourci : Ctrl 0",
    "divixHelp2": "Réglez le rapport d'affichage du système sur le rapport d'affichage recommandé par le système",
    "divixHelp2-desc": "(paramètres de Windows > système > affichage)",
    "divixHelp3": "Après l'ajustement, veuillez enregistrer le fichier et rafraîchir cette page",
    "download": "Téléchargez Google Chrome",
    "confirm": "En cours",
    "refreshNow": "Actualiser",
    "noRemind": "Pas de rappel"
  },
  "de": {
    "remind": "Hinweis ",
    "chrome-tips": "Der aktuelle Browser ist nicht vollständig kompatibel und einige Funktionen funktionieren nicht.",
    "ie-tips": "Der aktuelle Browser ist nicht mit EdrawMax Online kompatibel",
    "ratio-tips": "Leider ist die aktuelle Kompatibilität der Seitenskalierung schlecht",
    "ratio-tips-refresh": "Aktualisieren Sie die Seite, wenn die Anzeige unnormal ist",
    "chrome1": "Für eine bessere Erfahrung empfehlen wir die Verwendung von ",
    "chrome1-desc": "Google Chrome (100 % Kompatibilität).",
    "chrome2": "Wenn Sie einen Browser verwenden (wie z.B. 360/Sogou/QQ), der mehrere Modi unterstützt, wechseln Sie bitte in den Hochgeschwindigkeits-/Extremgeschwindigkeitsmodus.",
    "divixWarn": "Für Ihre bessere Erfahrung empfehlen wir Ihnen:",
    "divixHelp1": "Stellen Sie das Zoomverhältnis des Browsers auf 100 % ein",
    "divixHelp1-desc": "Tastenkombination: Strg + 0",
    "divixHelp2": "Passen Sie das Systemanzeigeverhältnis an das vom System empfohlene Anzeigeverhältnis an",
    "divixHelp2-desc": "(Windows-Einstellungen > System > Anzeige)",
    "divixHelp3": "Nach der Anpassung speichern Sie bitte die Datei und aktualisieren Sie diese Seite",
    "download": "Google Chrome Herunterladen",
    "confirm": "weiter",
    "refreshNow": "Aktualisieren",
    "noRemind": "Nicht erinnern"
  },
  "jp": {
    "remind": "通知",
    "chrome-tips": "現在のブラウザには完全な互換性がなく、一部の機能が動作しません。",
    "ie-tips": "現在のブラウザはEdrawMax Onlineと互換性がありません",
    "ratio-tips": "現在のページ拡大/縮小の互換性が不十分です",
    "ratio-tips-refresh": "正しく表示されない場合はページを更新してください",
    "chrome1": "快適にご使用いただくために、Google Chrome (100%の互換性) をお勧めします。",
    "chrome1-desc": "",
    "chrome2": "360/Sogou/QQなど複数のモードに対応しているブラウザをお使いの場合は、高速/超高速モードに切り替えてください。 ",
    "divixWarn": "快適にご使用いただくために、以下の方法をお試しください:",
    "divixHelp1": "ブラウザの表示サイズを100％の倍率に調整します",
    "divixHelp1-desc": "ショートカットキー：Ctrl 0",
    "divixHelp2": "システムのディスプレイの表示スケールを推奨の倍率に調整します",
    "divixHelp2-desc": "(Windowsの設定>システム>ディスプレイ)",
    "divixHelp3": "調整後、ファイルを保存してこのページを更新してください",
    "download": "Chrome をダウンロード",
    "confirm": "続行",
    "refreshNow": "更新",
    "noRemind": "再度表示しない"
  },
  "es": {
    "remind": "Recordatorio",
    "chrome-tips": "El navegador actual no es totalmente compatible y algunas funciones no servirán.",
    "ie-tips": "El navegador actual no es compatible con EdrawMax En Línea",
    "ratio-tips": "Lo sentimos, la compatibilidad de escala de página actual es deficiente",
    "ratio-tips-refresh": "Actualiza la página si se ve de forma anómala",
    "chrome1": "Para una mejor experiencia, recomendamos utilizar ",
    "chrome1-desc": "Google Chrome (100% compatible).",
    "chrome2": "Si utilizas un navegador que admite varios modos, como 360/Sogou/QQ, cambia al modo de alta velocidad/extrema velocidad.",
    "divixWarn": "Para una mejor experiencia, te recomendamos:",
    "divixHelp1": "Ajustar el ratio de zoom del navegador al 100%",
    "divixHelp1-desc": "tecla de acceso directo: Ctrl 0",
    "divixHelp2": "Ajusta la relación de pantalla del sistema a la recomendada por el sistema",
    "divixHelp2-desc": "(configuración de Windows > sistema > pantalla)",
    "divixHelp3": "Tras el ajuste, por favor, guarda el archivo y actualiza esta página",
    "download": "Descargar Google Chrome",
    "confirm": "Persistencia",
    "refreshNow": "Actualizar",
    "noRemind": "No recordar"
  },
  "pt": {
    "remind": "Alerta",
    "chrome-tips": "O navegador atual não é totalmente compatível e alguns recursos não funcionarão.",
    "ie-tips": "O navegador atual não é compatível com EdrawMax Online",
    "ratio-tips": "Desculpe, a compatibilidade atual do dimensionamento da página é ruim.",
    "ratio-tips-refresh": "Atualize a página se a exibição estiver anormal",
    "chrome1": "Para sua melhor experiência, recomendamos o uso do ",
    "chrome1-desc": "Google Chrome (100% compatível).",
    "chrome2": "Se você usar um navegador que ofereça suporte a vários modos, como 360/Sogou/QQ, por favor mude para o modo de alta velocidade/velocidade extrema.",
    "divixWarn": "Para sua melhor experiência, recomendamos que você:",
    "divixHelp1": "Ajuste a taxa de zoom do navegador para 100%",
    "divixHelp1-desc": "tecla de atalho: Ctrl 0",
    "divixHelp2": "Ajuste a proporção de exibição do sistema para a proporção de exibição recomendada pelo sistema",
    "divixHelp2-desc": "(configurações do Windows > sistema > exibição)",
    "divixHelp3": "Após o ajuste, por favor salve o arquivo e atualize esta página",
    "download": "Descarregar o Google Chrome",
    "confirm": "continuar",
    "refreshNow": "Actualizar",
    "noRemind": "Non ricordarmelo più"
  },
  "it": {
    "remind": "Promemoria",
    "chrome-tips": "Il browser attuale non è completamente compatibile e alcune funzionalità non funzioneranno.",
    "ie-tips": "Il browser attuale non è compatibile con EdrawMax Online",
    "ratio-tips": "Spiacenti, la compatibilità di ridimensionamento per la pagina corrente è scarsa`",
    "ratio-tips-refresh": "Aggiorna la pagina se la visualizzazione è anomala",
    "chrome1": "Per una migliore esperienza, ti consigliamo di utilizzare ",
    "chrome1-desc": "Google Chrome (compatibile al 100%).",
    "chrome2": "Se utilizzi un browser che supporta più modalità come 360/Sogou/QQ, passa alla modalità ad alta velocità/estrema velocità.",
    "divixWarn": "Per la tua migliore esperienza, ti consigliamo:",
    "divixHelp1": "Regola il rapporto di zoom del browser al 100%",
    "divixHelp1-desc": "tasto di scelta rapida: Ctrl 0",
    "divixHelp2": "Regolare il rapporto di visualizzazione del sistema in base al rapporto di visualizzazione consigliato dal sistema",
    "divixHelp2-desc": "(impostazioni di Windows > sistema > schermo)",
    "divixHelp3": "Dopo la regolazione, salva il file e aggiorna questa pagina",
    "download": "Scarica Google Chrome",
    "refreshNow": "Aggiorna",
    "noRemind": "continuare",
    "saveToGoogleSlideSuccess": "Sucesso ao Gravar"
  },
  "tw": {
    "remind": "温馨提示",
    "chrome-tips": "很抱歉，當前瀏覽器並未完全兼容，將會導致部分功能違法使用。",
    "ie-tips": "很抱歉，當前瀏覽器無法兼容億圖圖示在線版",
    "ratio-tips": "抱歉，目前頁面縮放比例相容性較差",
    "ratio-tips-refresh": "若顯示畫面異常，請重新整理頁面",
    "chrome1": "為了您有更好的使用體驗，我們建議您使用 ",
    "chrome1-desc": "谷歌瀏覽器（100%兼容）",
    "chrome2": "如果您正在使用360/搜狗/QQ等支持多種模式的瀏覽器，請嘗試切換至高速/極速模式。",
    "divixWarn": "為了您有更好的使用體驗，我們建議您:",
    "divixHelp1": "請嘗試調整瀏覽器縮放比例為100%",
    "divixHelp1-desc": "快捷键Ctrl + 0",
    "divixHelp2": "調整系統顯示比例為系統推薦顯示比例",
    "divixHelp2-desc": "(window設置>系統>顯示)",
    "divixHelp3": "調整後，請儲存檔案並刷新此頁面",
    "download": "下載谷歌瀏覽器",
    "confirm": "繼續使用",
    "refreshNow": "重新整理",
    "noRemind": "不再提醒"
  },
  "kr": {
    "remind": "알림",
    "chrome-tips": "현재 브라우저는 완전히 호환되는 것은 아니며 일부 기능이 작동하지 않을 수 있습니다.",
    "ie-tips": "현재 브라우저는 EdrawMax 온라인버전과 호환되지 않습니다",
    "ratio-tips": "죄송합니다. 현재 페이지 배율 호환성이 좋지 않습니다",
    "ratio-tips-refresh": "디스플레이가 비정상인 경우 페이지를 새로 고치세요",
    "chrome1": "더 나은 경험을 위해 구글 크롬(100% 호환)을 사용하는 것이 좋습니다.",
    "chrome1-desc": "",
    "chrome2": "다중 모드를 지원하는 브라우저를 사용하는 경우 하이 스피드 모드로 전환하세요.",
    "divixWarn": "더 나은 경험을 위해 아래 방법을 추천합니다:",
    "divixHelp1": "브라우저 확대/축소 비율을 100%로 조정",
    "divixHelp1-desc": "단축키: Ctrl 0",
    "divixHelp2": "시스템 디스플레이 비율을 시스템 권장 디스플레이 비율로 조정",
    "divixHelp2-desc": "(Windows 설정 > 시스템 > 디스플레이)",
    "divixHelp3": "조정 후 파일을 저장하고 이 페이지를 새로고침하세요",
    "download": "구글 크롭 다운로드하기",
    "refreshNow": "새로 고침",
    "noRemind": "더 이상 알람하지 않기",
    "confirm": "계속하기",
    "saveToGoogleSlideSuccess": "Google Slide에 저장되었습니다."
  }
}
</i18n>
